<template>


  <div v-show="isVisible" id="calc-app-container" class="col-12 col-md-6 col-lg-8 col-xl-4 calc   d-flex align-items-center  " :class="{
               
                'my-3 my-md-5 my-lg-2 my-xl-5': !isLocal,
                'local-container': isLocal
            }">



    <div id="calc-app" class="wrapper calc " data-app>

      <div class="row params dark-bg d-flex justify-content-between">

        <div class="col-auto me-auto amount-label d-flex align-items-end">Wybierz kwotę</div>
        <div class="col-auto amount text-end" v-cloak>
          {{loanAmount}} <span class="currency">zł</span>
        </div>


        <v-slider class="col-12 amount-slider mt-1 mb-3"
                  v-model="loanAmount"
                  :tick-labels="sliderLabels"
                  :min="minAmount"
                  :max="maxAmount"
                  :step="step"
                  ticks="always"
                  tick-size="4"
                  @input="onCalcSlide"
                  @end="onSlideEnd"></v-slider>




                  

        <div class="col-12 loan-period text-end">Okres 30 dni</div>


<!-- 
        <div class="col-auto me-auto amount-label d-flex align-items-end">Wybierz okres</div>
        <div class="col-auto amount text-end" v-cloak>
          {{loanTenor}} <span class="currency">mc</span>
        </div>

        <v-slider class="col-12 amount-slider mt-1 mb-3"
                  v-model="loanTenor"
              
                  :min="minTenor"
                  :max="maxTenor"
                 
                  :tick-labels="tenorLabels"
                  :step="tenorStep"

                  ticks="always"
                  tick-size="4"
                  @input="onCalcSlide"></v-slider> -->

<!-- 
        <div class="col-12 loan-period text-end">Okres 30 dni</div>
 -->

        <div class="col-12 cta my-4 text-center">
          <div class="mb-2">


            <a v-if="loanAmount <= firstTreshold && !isLocal" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goApplicate">Weź pożyczkę</a>


<!-- 
            <a v-if="loanAmount <= firstTreshold && isLocal" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goApplicate">Zatwierdź</a>
 -->

            <a v-if="loanAmount > firstTreshold" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goLogin">Zaloguj</a>


          </div>
      <!--     <div><a class="plain" href="#" data-bs-target="#CalcSliderModal" data-bs-toggle="modal">Formularz informacyjny</a></div> -->
          <div><a class="plain" href="javascript:void(0);" @click="goInfo" >Formularz informacyjny</a></div>
        </div>
      </div>

      <div class="row details">


       <!--  <div class="col-12 tabs d-flex">

          <div class="tab flex-fill " :class="{
               'active' : loanAmount <= firstTreshold

                            }"><a href="#">Pierwsza pożyczka</a></div>


          <div class="tab flex-fill" :class="{
               'active' : loanAmount>
            firstTreshold

            }"><a href="#">Kolejna pożyczka</a>
          </div>

        </div> -->


        <div class="col-12 tab-content">

          <div class="row ">
            <div class="col-sm-12 loan-details py-4 px-4">
              <div class="row">
                <div class="col col-auto me-auto">
                  Kwota:
                </div>
                <div class="col col-auto">
                  {{loanAmount}} zł
                </div>
              </div>
<!--               <div class="row">
                    <div class="col col-auto me-auto">
                        Miesięczna rata:
                    </div>
                    <div class="col col-auto">
                      {{installmentAmount}} zł
                    </div>
              </div> -->
              <div class="row">
                <div class="col col-auto me-auto">
                  Okres:
                </div>
                <div class="col col-auto">
                  {{loanTenor}} {{ tenorSign == 'd' ? 'dni' : 'mc' }}
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Data spłaty:
                </div>
                <div class="col col-auto">
                  {{finishDate}}
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Prowizja za udzielenie:
                </div>
                <div class="col col-auto">
                  {{commission}} zł
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Prowizja za obsługę:
                </div>
                <div class="col col-auto">
                  {{service}} zł
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Oprocentowanie:
                </div>
                <div class="col col-auto">
                  {{interest}} zł
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  RRSO:
                </div>
                <div class="col col-auto">
                  {{rrso}} %
                </div>
              </div>
              <div class="row summary">
                <div class="col col-auto me-auto">
                  Razem:
                </div>
                <div class="col col-auto">
                  {{total}} zł
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="CalcSliderModal" ref="modal">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header container dark-bg">
            <div class="col-auto me-auto ">
              <h3>Formularz</h3>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-html="formText">
          </div>

          <div class="modal-footer justify-content-center">

            <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>

            <!--
             <b-col lg="4" class="pb-2"><b-button type="button" size="lg" class="btn btn-secondary " data-bs-dismiss="modal">Zamknij</b-button></b-col> -->
          </div>

        </div>
      </div>
    </div>
  </div>



</template>

<script>
  import { info_form } from './modal_details.js';



    import __prm from './calc_params.json';


   

    export default {
        name: "CalcSlider",

        computed: {
          installmentAmount(){

            return (this.total / this.loanTenor).toFixed(2);
          },


          isLocal(){

            return !this.endpoint.length;
          }
            

        },


        components: {
          info_form
        },

        data(){
          return {
              params: [],

                isVisible: true,

                finishDate: '',

                service: '',
                commission: '',
                insurance: '',
                interest: '',
                rrso: '',
                total: '',
                dailyInterest: 0,

                loanAmount: 3000,
                loanTenor: 30,
                tenorSign: 'd',

                minTenor: 1,
                maxTenor: 1,
                tenorStep: 1,
                tenorLabels: ['30'],

                minAmount: 500,
                maxAmount: 8000,
                step: 100,

                firstTreshold: 10000,

                labelValues: [500, 4000, 8000],

                sliderLabels: [],

                modal: null,

                formText: ''
            }
        },


        props: {


            endpoint: {
                type: String,
                default: 'http://localhost:8080'
            }



        },

      

        methods: {

            onSlideEnd(){


              console.log('slide ended')

              if (this.isLocal && this.hasOwnProperty('echoValues')) {

                this.echoValues();
              }


            },


            onCalcSlide(){

              this.setValues(this.loanAmount, this.loanTenor, this.tenorSign);
            },



            setValues(v, t='30', s='d'){         


                if ( this.params.hasOwnProperty(String(t+s)) && this.params[t+s].hasOwnProperty(String(v)) ) {

                    let dat = this.params[t+s][v],
                        now = new Date(),
                        tom = new Date(Date.now() + t * 24*60*60*1000),
                        today = now.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1'),
                        tomorrow = tom.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1'),
                        newDate = s == 'm' ? new Date(now.setMonth(now.getMonth() + t)) : new Date(Date.now() + t * 24*60*60*1000),
                        iso = newDate.toISOString();


                    this.loanAmount = v;
                    this.loanTenor = t;
                    this.tenorSign = s;


                    this.total = this.tenorSign == 'm' ? ((dat[0] * (this.loanTenor-1)) + dat[1]).toFixed(2) : dat[1].toFixed(2);
               
                    this.interest = dat[2];
                    this.service = dat[3];
                    this.commission = dat[4];
                    this.insurance = dat[5];
                    this.rrso = dat[6];


                    this.finishDate = iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');


                    this.dailyInterest = parseInt(this.commission) / 30;


                  let patt, rep;

                  this.formText = [
                    ['{m%POZYCZKA.KAPITAL}', this.loanAmount],
                    ['{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}', this.total],
                    ['{POZYCZKA.OPROCENTOWANIE_STOPA}', '18.5'],
                    ['{POZYCZKA.STOPA_NBP}', '22.5'],
                    ['{POZYCZKA.LICZBA_DNI}', this.loanTenor],
                    ['{POZYCZKA.LICZBA_RAT}', this.loanTenor],
                    ['{m%POZYCZKA.KWOTA_RATY}', (this.total/this.loanTenor).toFixed(2)],
                    ['{POZYCZKA.KOSZT}', this.service + this.interest + this.commission],
                    ['{m%POZYCZKA.CALKOWITY_KOSZT_POZYCZKI}', this.service + this.interest + this.commission],
                    ['{POZYCZKA.OKRES}', this.loanTenor],
                    ['{POZYCZKA.DATA_WNIOSKU}', today],
                    ['{POZYCZKA.DATA_WNIOSKU_PLUS_1D}', tomorrow],
                    ['{POZYCZKA.RRSO}', this.rrso+' '],
                    ['{POZYCZKA.DATA_SPLATY}r.', this.finishDate+'r.'],
                    ['{POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                    ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                    ['{m%POZYCZKA.OPLATA_ZA_OBSLUGE}', this.service],
                    ['{POZYCZKA.OPLATA_ZA_OBSLUGE}', this.service],
                    ['{POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{m%POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)]
                  ]
                  .reduce((acc, itm) => {

                    return acc.replaceAll(new RegExp(itm[0], 'g'), itm[1]);
                  }, info_form);

                }

            },


            goApplicate(){

                if (this.isLocal && this.hasOwnProperty('echoValues')) {

                  this.echoValues();

                  this.echo('calc_edit_done');
                }
                else {
                  window.location = this.endpoint + '?amount=' + this.loanAmount;
                }
            },

            goInfo(){

                if (this.isLocal && this.hasOwnProperty('echoValues')) {

                  this.echoValues();

                  this.modal.show();
                }
                else {
                  window.location = this.endpoint + '/#/info?amount=' + this.loanAmount;
                }
            },


            goLogin(){

              if (this.isLocal && this.hasOwnProperty('echo')) {

                this.echo('login_dialog');
              }
              else {

                window.location = this.endpoint + '?login';
              }
            }

         
        },     





        created() {




            let now = new Date(), 

                newDate = this.tenorSign == 'm' ? new Date(now.setMonth(now.getMonth() + this.loanTenor)) : new Date(Date.now() + this.loanTenor * 24*60*60*1000), 
                iso = newDate.toISOString();


            this.finishDate = iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');



            if (typeof __prm == 'object') {
                let t, i, o;
                for (t in __prm) {
                    if (__prm.hasOwnProperty(t)) {
                        for (i in __prm[t]) {
                            if (__prm[t].hasOwnProperty(i)) {
                                o = String(i).split('_');

                                // init
                                this.params[o[1]] = this.params[o[1]] || [];

                                this.params[o[1]][ '' + String(o[0].replace('-', '.') * 100) ] = __prm[t][i];
                            }
                        }
                    }
                }


                // initial
                this.setValues(this.loanAmount, this.loanTenor, this.tenorSign);


                this.sliderLabels = this.labelValues.reduce((accu, itm) => {

                  if (!accu){
                    return [itm];
                  }

                  return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
                }, 0);


            }

          
        },

        mounted(){



          this.modal = new bootstrap.Modal(this.$refs['modal']);



        }
    }
</script>


<style scoped>
  .modal-dialog {
    max-width: 900px;
  }


  .modal-header {
    display: flex;
  }

  .modal-title {
    color: #fefefe;
  }

  .modal-body {
    overflow-y: auto;
  }


  .local-container {

    padding-top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/CalcSlider.vue